// MIME types the editor's HTML5 drags carry, in one place so the source of a
// drag and every drop target agree without importing each other's components.

/** A library entry (the whole `LibraryClipEntry`, JSON). */
export const LIBRARY_DRAG_TYPE = "application/x-seedbed-library";

/** A Session View clip (its clip id). */
export const SLOT_DRAG_TYPE = "application/x-seedbed-slot-clip";

/**
 * A piece of the room's OWN material, offered as something to build with —
 * the clip id of one occurrence of it. Distinct from `SLOT_DRAG_TYPE` because
 * the material shelf drags timeline clips too, and from `LIBRARY_DRAG_TYPE`
 * because nothing has to be fetched: the clip is already in the room, so the
 * drop is a copy rather than a placement.
 */
export const MATERIAL_DRAG_TYPE = "application/x-seedbed-material";

/**
 * A clip from the producer's own library ("Mine" on the material shelf) —
 * its library clip id. Unlike MATERIAL_DRAG_TYPE the audio isn't in the room
 * yet, so the drop is a placement of new audio, not a copy.
 */
export const MINE_DRAG_TYPE = "application/x-seedbed-mine-clip";

/** A MIDI idea from the producer's library ("Mine") — its library id. The
 * notes travel with the drop; nothing is fetched. */
export const MINE_MIDI_DRAG_TYPE = "application/x-seedbed-mine-midi";

/** A folder of the producer's library — its id. Dropped on another folder
 * (or a crumb) it moves there, with everything in it. Nothing outside the
 * shelf takes it. */
export const MINE_FOLDER_DRAG_TYPE = "application/x-seedbed-mine-folder";
